import script from "./QuickAccessSection.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickAccessSection.vue?vue&type=script&setup=true&lang=js"

import "./QuickAccessSection.vue?vue&type=style&index=0&id=b99f2b3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b99f2b3a"]])

export default __exports__